'use client'

import { Suspense } from 'react'
import { useLoginForm } from './_hooks/use-login-form'
import { LoginForm } from './_components/login-form'

function LoginPageInner() {
  const formProps = useLoginForm()
  return <LoginForm {...formProps} />
}

export default function LoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen" />}>
      <LoginPageInner />
    </Suspense>
  )
}
